<template>
  <div class="export-btn">
    <el-tooltip
      effect="dark"
      content="系统分配线索不支持数据导出"
      v-if="exportTemplate === 'SalesLeadList'"
    >
        <el-button
          :type="type"
          :size="size"
          @click="handleExport"
          :loading="loading"
        >{{ text }}<i class="el-icon-warning el-icon--right"></i>
        </el-button>
    </el-tooltip>
    <el-button
      v-else
      :type="type"
      :size="size"
      @click="handleExport"
      :loading="loading"
      :icon="isShowIcon?'QS-icon-import':''"
    >{{ text }}</el-button>
  </div>
</template>

<script>
import * as exportApi from '@/api/export'
import moment from 'moment'

export default {
  name: 'export',
  props: {
    params: {
      type: Object,
      default: () => ({}),
    },
    size: {
      type: String,
      default: 'small',
    },
    type: {
      type: String,
      default: '',
    },
    text: {
      type: String,
      default: '导出数据',
    },
    filename: {
      type: String,
      default: 'excel.xlsx',
    },
    exportTemplate: {
      type: String,
      default: 'tenant',
    },
    isShowIcon: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    handleExport() {
      // 应收管理判断开始-结束时间间隔不能大于6个月
      // TODO 待后端修复问题后代码下线
      const reqParams = { ...this.params }

      if (this.exportTemplate === 'Receivable') {
        const { startDate, endDate } = reqParams

        if (!startDate || !endDate) return this.$message.error('应收开始结束时间不能为空')

        const start = moment(startDate, 'YYYY-MM-DD 23:59:59')
        const end = moment(endDate, 'YYYY-MM-DD 23:59:59')

        const sixMonthsBeforeEndDate = end.subtract(6, 'months')

        const isStartDateBeforeSixMonths = start.isBefore(sixMonthsBeforeEndDate)

        if (isStartDateBeforeSixMonths) {
          return this.$message.error('应收开始到结束时间间隔不能大于6个月')
        }
      }


      if (this.loading) return false
      this.loading = true
      const exportTemplate = this.exportTemplate.substr(0, 1).toUpperCase() + this.exportTemplate.substr(1)
      exportApi[`export${exportTemplate}`](reqParams).then((data) => {
        if (data) {
          const { type } = data
          if (type.includes('application/json')) {
            data.text().then((res) => {
              try {
                const { msg } = JSON.parse(res)
                this.$message.error(msg)
              } catch {
                this.$message.error('导出失败')
              }
            })
            return
          }
          const url = window.URL.createObjectURL(
            new Blob([data], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            }),
          )
          const link = document.createElement('a')
          link.style.display = 'none'
          link.href = url
          link.setAttribute('download', this.filename)
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        }
      }).finally(() => {
        this.loading = false
      })
    },
  },
}
</script>
